import { CloudDownloadOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

import type Template from 'stores/Template';

import DrawerButton from '../DrawerButton';

const CloudDownloadIcon = styled(CloudDownloadOutlined)`
  font-size: 20px;
  padding-top: 4px;
`;

export interface DownloadButtonProps {
  template: Template;
}

function DownloadButton({ template }: DownloadButtonProps) {
  const { downloadURL, loading } = template;
  const canDownload = Boolean(downloadURL && !loading);

  return (
    <DrawerButton disabled={!canDownload} href={downloadURL}>
      <CloudDownloadIcon />
    </DrawerButton>
  );
}

export default DownloadButton;
